import { render } from "./QuoteRespDetail.vue?vue&type=template&id=40376448&scoped=true"
import script from "./QuoteRespDetail.vue?vue&type=script&lang=js"
export * from "./QuoteRespDetail.vue?vue&type=script&lang=js"

import "./QuoteRespDetail.vue?vue&type=style&index=0&id=40376448&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40376448"]])

export default __exports__